var map = {
	"./ClientMapping": 683349,
	"./CreditnoteMapping": 716527,
	"./DeliveryMapping": 308100,
	"./EstimateMapping": 970514,
	"./InvoiceMapping": 693995,
	"./OpportunityMapping": 593917,
	"./OrderMapping": 117110,
	"./PeopleMapping": 181441,
	"./ProformaMapping": 170016,
	"./PropdocumentMapping": 662516,
	"./ProspectMapping": 345476,
	"./PurCreditNoteMapping": 37200,
	"./PurDeliveryMapping": 260539,
	"./PurInvoiceMapping": 529826,
	"./PurOrderMapping": 774307,
	"./StaffMapping": 187976,
	"./SupplierMapping": 304560,
	"./ThirdMapping": 119293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291531;